<div class="input-container">
    <div class="input-wrapper">
        <input
            #cellInput
            [formControlName]="formControlName"
            class="input-field"
            [class.input-field--wide]="wide"
            [value]="cell.selectedQuantity"
            [attr.placeholder]="cell.placeholder || null"
            numbersOnly
            noLeadingZero
            maxlength="3"
            (click)="onClick()"
            [attr.data-id]="cell.id"
            (blur)="onInputBlur($event)"
            (focusin)="onInputFocusIn($event)"
            (focusout)="onInputFocusOut($event)"
            [id]="inputId"
        />
        <p class="input-display" *ngIf="cell.isAvailableQuantityVisible">/{{ cell.availableQuantity || 0 }}</p>
    </div>
    <div class="input-icon">
        <div #cellIcon>
            <fcp-icon *ngIf="cell.iconTooltip" [icon]="['far', 'calendar-days']"></fcp-icon>
        </div>
    </div>
</div>

<fcp-tooltip
    *ngIf="cell.inputTooltip"
    [open]="isTooltipVisible | async"
    [overlayOrigin]="cellInput"
    [customPosition]="tooltipPosition"
>
    {{ cell.inputTooltip }}
</fcp-tooltip>

<fcp-tooltip
    *ngIf="cell.iconTooltip"
    [open]="isIconTooltipVisible | async"
    [overlayOrigin]="cellIcon"
    [customPosition]="tooltipPosition"
>
    <div>
        {{ cell.iconTooltip.available }}
    </div>
    {{ cell.iconTooltip.backorder }}
</fcp-tooltip>
